import { FulfillmentStatus, FulfillmentType } from '@/cowboy/EnumTypes'

export class RedeemedItem {
  constructor (args) {
    const {
      brandName,
      createdAt,
      currencyCode,
      fulfillmentType,
      imageUrl,
      lineItemFees,
      lineItemSubtotal,
      lineItemTotal,
      obfuscatedDeliveryEmailAddress,
      orderTotal,
      quantity,
      referenceLineItemId,
      rewardType,
      directPaymentMetadata,
      status,
      deliveryStatus,
      deliveryDate
    } = args || {}
    this.brandName = brandName
    this.createdAt = createdAt
    this.currencyCode = currencyCode
    this.fulfillmentType = fulfillmentType
    this.imageUrl = imageUrl
    this.lineItemFees = lineItemFees
    this.lineItemSubtotal = lineItemSubtotal
    this.lineItemTotal = lineItemTotal
    this.obfuscatedDeliveryEmailAddress = obfuscatedDeliveryEmailAddress
    this.orderTotal = orderTotal
    this.quantity = quantity
    this.referenceLineItemId = referenceLineItemId
    this.rewardType = rewardType
    this.directPaymentMetadata = directPaymentMetadata
    this.status = status
    this.deliveryStatus = deliveryStatus
    this.deliveryDate = deliveryDate
  }

  get isPhysical () {
    return this.fulfillmentType === FulfillmentType.PHYSICAL
  }

  get isDigital () {
    return this.fulfillmentType === FulfillmentType.DIGITAL
  }

  get isUnsuccessful () {
    return this.status === FulfillmentStatus.FAILED
  }

  get isSuccessful () {
    return this.status === FulfillmentStatus.COMPLETE
  }

  setDeliveryStatus (status) {
    this.deliveryStatus = status
  }
}
